import { generateURL } from 'utils/helpers';

const property = {
  getProperties: (params, fetchParams) => {
    const url = generateURL('/properties', params);
    return fetch(url, {
      method: 'GET',
      ...fetchParams,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status !== undefined) {
          return Promise.reject(data);
        }
        return data;
      });
  },
  getProperty: (propertyId, params) => {
    const url = generateURL(`/property/${propertyId}`, params);
    return fetch(url, {
      method: 'GET',
    }).then((response) => response.json());
  },
};

export default property;
